import Vue from 'vue'

import {
  Quasar,
  QLayout,
  QHeader,
  QFooter,
  QDrawer,
  QPageContainer,
  QPage,
  QBtn,
  QBtnDropdown,
  QBtnGroup,
  QCard,
  QCardSection,
  QCardActions,
  QChip,
  QDialog,
  QEditor,
  QExpansionItem,
  QIcon,
  QInput,
  QSelect,
  QForm,
  QField, // DO NOT USE for q-input
  QRadio,
  QCheckbox,
  QToggle,
  QOptionGroup,
  QSlider,
  QDate,
  QInnerLoading,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QPopupEdit,
  QRating,
  QScrollArea,
  QSeparator,
  QSlideTransition,
  QSpinnerAudio,
  QSpinnerDots,
  QStepper,
  QStep,
  QStepperNavigation,
  QTable,
  QTh,
  QTr,
  QTd,
  QTabs,
  QTab,
  QRouteTab,
  QTabPanels,
  QTabPanel,
  QToolbar,
  QToolbarTitle,
  QTooltip,
  QUploader,
  LocalStorage,
  Notify,
  Dialog,
  ClosePopup,
  Ripple,
  QMenu,
  QLinearProgress,
  QPopupProxy,
  QBar,
  QSpace,
  QBadge,
  QSpinner,
  QAvatar,
  QTree,
  QSplitter,
  QBanner,
  QSpinnerHourglass,
  QImg,
  QFile,
  QResizeObserver,
  QScrollObserver,
  QSpinnerCube,
  Loading
} from 'quasar'

import 'quasar/dist/quasar.ie.polyfills'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/ionicons-v4/ionicons-v4.css'
import '@quasar/extras/mdi-v3/mdi-v3.css'
import '@quasar/extras/eva-icons/eva-icons.css'
import svgMdiV5 from 'quasar/icon-set/svg-mdi-v5'

Vue.use(Quasar, {
  supportIE: true,
  iconSet: svgMdiV5,
  config: {},
  components: {
    Quasar,
    QLayout,
    QHeader,
    QFooter,
    QDrawer,
    QPageContainer,
    QPage,
    QBtn,
    QBtnDropdown,
    QBtnGroup,
    QCard,
    QCardSection,
    QCardActions,
    QChip,
    QDialog,
    QEditor,
    QExpansionItem,
    QIcon,
    QInput,
    QSelect,
    QForm,
    QField, // DO NOT USE for q-input
    QRadio,
    QCheckbox,
    QToggle,
    QOptionGroup,
    QSlider,
    QDate,
    QInnerLoading,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QPopupEdit,
    QRating,
    QScrollArea,
    QSeparator,
    QSlideTransition,
    QSpinnerAudio,
    QSpinnerDots,
    QStepper,
    QStep,
    QStepperNavigation,
    QTable,
    QTh,
    QTr,
    QTd,
    QTabs,
    QTab,
    QRouteTab,
    QTabPanels,
    QTabPanel,
    QToolbar,
    QToolbarTitle,
    QTooltip,
    QUploader,
    LocalStorage,
    Notify,
    Dialog,
    ClosePopup,
    Ripple,
    QMenu,
    QLinearProgress,
    QPopupProxy,
    QBar,
    QSpace,
    QBadge,
    QSpinner,
    QAvatar,
    QTree,
    QSplitter,
    QBanner,
    QSpinnerHourglass,
    QImg,
    QFile,
    QResizeObserver,
    QScrollObserver,
    QSpinnerCube
  },
  extras: ['material-icons', 'fontawesome-v5', 'roboto-font'],
  plugins: [LocalStorage, Notify, Dialog, Loading],
  directives: [ClosePopup, Ripple]
})
